<template>
  <div>
    <vs-prompt
      :title="isNew ? 'Add terminal' : 'Update terminal'"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      :accept-text="isNew ? 'Add' : 'Update'"
      :is-valid="validForm"
      class=""
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input v-model="name" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Location</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select
                v-model="locationId"
                label="Location"
                placeholder="Select location"
              >
                <vs-select-item
                  :key="item.locationId.id"
                  :value="item.locationId.id"
                  :text="item.name"
                  v-for="item in venue.locations"
                />
              </vs-select>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Must request tip</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-checkbox v-model="mustRequestTip" />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      existingId: null,
      name: "",
      locationId: null,
      mustRequestTip: false,
      prompt: false,
    };
  },
  computed: {
    ...mapGetters({
      venue: "pos/venues/venue",
    }),
    isNew() {
      return !this.existingId;
    },
    validForm() {
      return this.locationId !== null;
    },
  },
  methods: {
    show(withTerminal) {
      this.name = "";
      this.existingId = null;
      this.locationId = null;
      this.mustRequestTip = false;

      if (withTerminal) {
        this.existingId = withTerminal.id;
        this.name = withTerminal.name;
        this.mustRequestTip = withTerminal.mustRequestTip;
        if (withTerminal.locationId)
          this.locationId = withTerminal.locationId.id;
      }
      this.prompt = true;
    },
    async accept() {
      this.$vs.loading();

      if (this.isNew) {
        await this.$store.dispatch("pos/venues/createTerminal", {
          venueId: this.venue.id,
          terminalName: this.name,
          locationId: this.locationId,
          mustRequestTip: this.mustRequestTip,
        });
      } else {
        await this.$store.dispatch("pos/venues/updateTerminal", {
          venueId: this.venue.id,
          terminalId: this.existingId,
          terminalName: this.name,
          locationId: this.locationId,
          mustRequestTip: this.mustRequestTip,
        });
      }

      this.$vs.notify({
        color: "success",
        title: `Venue updated`,
        text: "Venue updated",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
